import { FileText, Link2, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const IngestSources = ({
  tab, setTab, url, setUrl, addUrl, busy, blocked, openPaste,
  files, setFiles, imageUrls, setImageUrls, addFiles,
  manual, setManual, addText,
}) => (
  <Tabs value={tab} onValueChange={setTab} className="mb-10">
    <TabsList data-testid="ingest-tabs">
      <TabsTrigger value="enlace" data-testid="tab-enlace">Enlace</TabsTrigger>
      <TabsTrigger value="archivos" data-testid="tab-archivos">Archivos</TabsTrigger>
      <TabsTrigger value="texto" data-testid="tab-texto">Texto / HTML</TabsTrigger>
    </TabsList>

    <TabsContent value="enlace" className="border border-border bg-card p-6 mt-4">
      <Label className="text-xs uppercase tracking-wider">URL de la noticia o nota de prensa</Label>
      <div className="flex flex-col sm:flex-row gap-3 mt-2">
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://ejemplo.do/nota-de-prensa"
          data-testid="ingest-url-input"
        />
        <Button onClick={addUrl} disabled={!url || busy === "url"} data-testid="ingest-url-btn">
          <Link2 className="h-4 w-4 mr-2" />
          {busy === "url" ? "Leyendo…" : "Extraer"}
        </Button>
      </div>
      {blocked && (
        <div className="mt-4 border border-destructive/40 bg-destructive/5 p-4" data-testid="blocked-alert">
          <p className="text-sm font-medium text-destructive">Este sitio bloquea la lectura automática</p>
          <p className="text-xs text-muted-foreground mt-1">{blocked.message}</p>
          <div className="flex flex-wrap gap-2 mt-3">
            <Button size="sm" onClick={openPaste} data-testid="paste-text-btn">
              <FileText className="h-3.5 w-3.5 mr-1.5" />Pegar el texto
            </Button>
            <Button size="sm" variant="outline" asChild>
              <a href={blocked.url} target="_blank" rel="noreferrer" data-testid="open-source-btn">
                Abrir la nota
              </a>
            </Button>
            <Button size="sm" variant="outline" onClick={addUrl} disabled={busy === "url"}
                    data-testid="retry-url-btn">
              Reintentar
            </Button>
          </div>
        </div>
      )}
    </TabsContent>

    <TabsContent value="archivos" className="border border-border bg-card p-6 mt-4 space-y-4">
      <div>
        <Label className="text-xs uppercase tracking-wider">Documentos e imágenes (.docx, .pdf, .html, .txt, jpg, png)</Label>
        <Input
          type="file"
          multiple
          className="mt-2"
          onChange={(e) => setFiles(Array.from(e.target.files || []))}
          data-testid="ingest-file-input"
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wider">URLs de imágenes adicionales (separadas por coma)</Label>
        <Input value={imageUrls} onChange={(e) => setImageUrls(e.target.value)} className="mt-2" data-testid="ingest-image-urls" />
      </div>
      <Button onClick={addFiles} disabled={!files.length || busy === "files"} data-testid="ingest-files-btn">
        <Upload className="h-4 w-4 mr-2" />
        {busy === "files" ? "Procesando…" : `Cargar ${files.length || ""}`}
      </Button>
    </TabsContent>

    <TabsContent value="texto" className="border border-border bg-card p-6 mt-4 space-y-4">
      {manual.source_url && (
        <p className="text-xs mono text-muted-foreground" data-testid="paste-source-url">
          Enlace de origen: {manual.source_url}
        </p>
      )}
      <Input
        placeholder="Título de la nota"
        value={manual.title}
        onChange={(e) => setManual({ ...manual, title: e.target.value })}
        data-testid="ingest-text-title"
      />
      <Textarea
        rows={8}
        placeholder="Pegue aquí el texto plano o HTML de la nota de prensa…"
        value={manual.text}
        onChange={(e) => setManual({ ...manual, text: e.target.value })}
        data-testid="ingest-text-body"
      />
      <Input
        placeholder="URLs de imágenes separadas por coma"
        value={manual.images}
        onChange={(e) => setManual({ ...manual, images: e.target.value })}
        data-testid="ingest-text-images"
      />
      <Button onClick={addText} disabled={manual.text.length < 80 || busy === "text"} data-testid="ingest-text-btn">
        {busy === "text" ? "Guardando…" : "Añadir a la bandeja"}
      </Button>
    </TabsContent>
  </Tabs>
);
